export default __webpack_public_path__ + "static/pettingStanding-faaa588c8583315f158a6d41cd12a24f.svg";